/**
 * External dependencies
 */
import { css } from 'emotion';

export const FormGroup = css`
	width: 100%;
`;
